import * as moment from "moment";

import { SdpIcon } from "./common/icon/models";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";

export function isWebUrl(value: string) {
	// tslint:disable-next-line:max-line-length
	const regex = new RegExp(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(((?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))|([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}))(:[0-9]{1,5})?(?:[/?#]\S*)?$/i);
	return regex.test(value.trim());
}

export function getAccountName() {
	const domain = window.location.hostname;
	return (domain.split("."))[0];
}

export function showTimeFromEpoch(value: number) {
	if (!value) {
		return undefined;
	}
	const expiry = moment(value);
	return expiry.format("MM/DD/YYYY LTS");
}

/**
 * Intended to be used as the display callback to a "dateTime" body schema in the generic table.
 *
 * @param placeholder if no dateTime value is provided, the resulting callback will return this string
 */
export function createDateTimeDisplayCallback(placeholder: string = "&nbsp;"): (value: string) => string {
	return (date: string): string => {
		if (!!date) {
			return showTimeFromEpoch(parseInt(date, 10)) || placeholder;
		} else {
			return placeholder;
		}
	};
}

export function getPath(url: string) {
	return url.indexOf("administration") >= 0 ? "administration" : "wizard";
}

export function randomNumber(value: number) {
	// returns an integer between 0 and value
	return Math.floor(Math.random() * Math.floor(value));
}

export function isHttpResponse(error: any): error is HttpResponse<any> {
	return (<Response>error).statusText !== undefined;
}

export function isHttpErrorResponse(e: any): e is HttpErrorResponse {
	if (isHttpResponse(e)) {
		if (typeof (e as any).error === "object" && typeof (e as any).error.messsage === "string") {
			return true;
		}
	}
	return false;
}

export function shortenPhrase(value: string, maxLength: number) {
	if (value.length > maxLength) {
		return `${value.substring(0, maxLength)}...`;
	} else {
		return value;
	}
}

export function isPromiseLike<T>(x: T | PromiseLike<T> | undefined): x is PromiseLike<T> {
	if (!x) {
		return false;
	}
	if (typeof x !== "object" && typeof x !== "function") {
		return false;
	}
	return typeof (x as PromiseLike<T>).then === "function";
}

export const supportEmail = "support@impulse.com";

export const tableEditIcon: SdpIcon.Icon = { type: "material", name: "mode_edit", cssClass: "sdp-icon-button-icon" };
export const tableDeleteIcon: SdpIcon.Icon = { type: "material", name: "delete_forever", cssClass: "sdp-icon-button-icon" };
export const tableDownloadIcon: SdpIcon.Icon = { type: "material", name: "get_app", cssClass: "sdp-icon-button-icon" };
